// Tabs must not change each other's state, yet a new tab starts from the last one any tab left:
// sessionStorage is the tab's own copy, localStorage the seed. Either may be unavailable; a failed
// access reads as unset.

function attempt<T>(access: () => T, fallback: T): T {
  try {
    return access();
  } catch {
    return fallback;
  }
}

export const tabStorage = {
  // The seed is copied on first read, so a reload keeps what this tab saw, not what another tab wrote since.
  getItem(key: string): string | null {
    const own = attempt(() => sessionStorage.getItem(key), null);
    if (own !== null) return own;
    const seed = attempt(() => localStorage.getItem(key), null);
    if (seed !== null) attempt(() => sessionStorage.setItem(key, seed), undefined);
    return seed;
  },
  setItem(key: string, value: string) {
    attempt(() => sessionStorage.setItem(key, value), undefined);
    attempt(() => localStorage.setItem(key, value), undefined);
  },
  removeItem(key: string) {
    attempt(() => sessionStorage.removeItem(key), undefined);
    attempt(() => localStorage.removeItem(key), undefined);
  },
};
